import { useEffect, useState } from "react";
import { Cookie } from "lucide-react";

const STORAGE_KEY = "sedio_cookie_consent_v1";

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const decide = (choice) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ choice, at: new Date().toISOString() }));
    } catch { /* ignore */ }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      className="fixed bottom-0 left-0 right-0 z-[300] border-t border-border bg-card/95 backdrop-blur-md shadow-2xl animate-in fade-in slide-in-from-bottom-2 duration-300"
      role="dialog"
      aria-live="polite"
      aria-label="Informativa cookie"
    >
      <div className="mx-auto max-w-6xl px-4 py-2.5 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
        <div className="flex items-center gap-2.5 min-w-0 flex-1">
          <Cookie className="h-4 w-4 text-[#007BFF] shrink-0" />
          <p className="text-[12px] sm:text-[13px] text-muted-foreground leading-snug">
            Usiamo solo <strong className="text-foreground">cookie tecnici</strong> necessari al funzionamento.{" "}
            <a
              href="/legale?doc=cookie"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="cookie-consent-policy-link"
              className="text-[#007BFF] hover:underline font-medium"
            >
              Cookie Policy
            </a>
          </p>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <button
            data-testid="cookie-consent-reject"
            onClick={() => decide("rejected")}
            className="text-[12px] sm:text-[13px] font-medium px-3.5 py-1.5 rounded-md border border-border text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
          >
            Rifiuta
          </button>
          <button
            data-testid="cookie-consent-accept"
            onClick={() => decide("accepted")}
            className="text-[12px] sm:text-[13px] font-semibold px-4 py-1.5 rounded-md bg-[#007BFF] hover:bg-[#0056B3] text-white transition-colors"
          >
            Accetta
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
